<app-topnav [pageName]="pageName"></app-topnav>
<div class="container">
  <div class="content user-mgmt-page" role="main">
    <header class="user-mgmt-page__header">
      <div>
        <h1 class="user-mgmt-page__title">Invitation Management</h1>
        <p class="user-mgmt-page__subtitle">Search, filter, and manage BounceBack participant invitations.</p>
        @if (totalRecords > 0) {
          <div class="user-mgmt-page__meta">
            <span class="user-mgmt-page__count">{{ totalRecords | number }} invitations found</span>
          </div>
        }
      </div>
      <div class="user-mgmt-page__actions">
        @if (showAddButton) {
          <a routerLink="/create-bb-invitation" class="user-mgmt-page__btn user-mgmt-page__btn--primary">
            <mat-icon>add</mat-icon>
            Create Invitation
          </a>
        }
      </div>
    </header>

    <section class="user-mgmt-page__filters">
      <form (ngSubmit)="search()">
        <div class="user-mgmt-page__filters-grid">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Search</mat-label>
            <mat-icon matPrefix>search</mat-icon>
            <input matInput class="form-control-textbox" name="filterSearch" [(ngModel)]="queryFilter.InvitationSearchKeyword" placeholder="Email or case ID" />
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Coach</mat-label>
            <mat-select placeholder="All Coaches" name="filterCoach" [(ngModel)]="queryFilter.Coach">
              <mat-option value="0">All Coaches</mat-option>
              @for (cp of coachedUsers; track cp) {
                <mat-option [value]="cp.userDbId">{{ cp.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Status</mat-label>
            <mat-select placeholder="All Statuses" name="filtercoursestatus" [(ngModel)]="queryFilter.Status">
              <mat-option value="ALL">All Statuses</mat-option>
              <mat-option value="ACTIVE">Active</mat-option>
              <mat-option value="INACTIVE">All Inactive</mat-option>
              <mat-option value="INACTIVEEXPIRED">Inactive-Expired</mat-option>
              <mat-option value="INACTIVEWITHDRAWN">Inactive-Withdrawn</mat-option>
              <mat-option value="INACTIVEUSED">Inactive-Used</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="user-mgmt-page__filters-actions">
          <button class="user-mgmt-page__btn user-mgmt-page__btn--primary" type="submit" #submitButton>
            <mat-icon>filter_list</mat-icon>
            Apply Filters
          </button>
          <button class="user-mgmt-page__btn user-mgmt-page__btn--secondary" type="button" (click)="resetFilters()">
            <mat-icon>restart_alt</mat-icon>
            Reset
          </button>
        </div>
      </form>
    </section>

    <section class="user-mgmt-page__table-card">
      <ng-container *ngTemplateOutlet="table; context: { data: bbinvitationslist, headerVisible: true }"></ng-container>
      <mat-paginator
        #paginator
        [length]="totalRecords"
        [pageSize]="25"
        [hidden]="totalRecords === 0"
        [pageSizeOptions]="[10, 25, 50]"
        (page)="handlePageEvent($event)"
        aria-label="Invitation list pagination">
      </mat-paginator>
    </section>
  </div>
</div>

<ng-template #table let-data="data" let-headerVisible="headerVisible">
  <app-no-results #noResults></app-no-results>

  <table mat-table class="fileList primary" [dataSource]="data" [hidden]="data.length === 0">
    <ng-container matColumnDef="caseid">
      <th mat-header-cell *matHeaderCellDef>Case ID #</th>
      <td mat-cell *matCellDef="let result">{{ result.caseId }}</td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>Email</th>
      <td mat-cell *matCellDef="let result">
        <a [routerLink]="['/view-bb-invitation', result.id]" class="user-mgmt-page__user-link">{{ result.email }}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="coach">
      <th mat-header-cell *matHeaderCellDef>Coach</th>
      <td mat-cell *matCellDef="let result">{{ result.coach }}</td>
    </ng-container>

    <ng-container matColumnDef="expirydate">
      <th mat-header-cell *matHeaderCellDef class="w-130">Expiry Date</th>
      <td mat-cell *matCellDef="let result">{{ result.expiryDate }}</td>
    </ng-container>

    <ng-container matColumnDef="linkaccessed">
      <th mat-header-cell *matHeaderCellDef>Link Accessed</th>
      <td mat-cell *matCellDef="let result">{{ result.linkAccessed }}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>
        Status
        <app-information-popup [information]="information"></app-information-popup>
      </th>
      <td mat-cell *matCellDef="let result">
        <app-status-bubble [status]="result.status" [statusDescription]="result.statusDescription"></app-status-bubble>
      </td>
    </ng-container>

    @if (headerVisible) {
      <tr mat-header-row *matHeaderRowDef="columnsToDisplay" class="tableHeader"></tr>
    }
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
  </table>
</ng-template>

<app-footer></app-footer>
